export const validateLogin = ({ username, password }) => {
  const errors = {
    username: [],
    password: [],
  };

  let flag = true;

  if (!username) {
    flag = false;
    errors["username"].push("El campo username es requerido");
  }
  if (!password) {
    flag = false;
    errors["password"].push("El campo password es requerido");
  }
  return {
    success: flag,
    errors: errors,
  };
};
